export function useDateMiddleware(store, dateFields = []) {
  const pad = (n) => String(n).padStart(2, '0')

  const localToUTCISO = (value) => {
    if (!value) return null

    if (typeof value === 'string' && value.includes('T')) {
      const d = new Date(value)
      return isNaN(d.getTime()) ? null : d.toISOString()
    }

    const match = value.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:\s(\d{2}):(\d{2})(?::(\d{2}))?)?$/
    )
    if (!match) return null

    const [, y, m, d, h = '0', min = '0', s = '0'] = match

    const localDate = new Date(
      Number(y),
      Number(m) - 1,
      Number(d),
      Number(h),
      Number(min),
      Number(s)
    )

    return localDate.toISOString()
  }

  const utcToLocalString = (iso, withTime = false) => {
    if (!iso) return null
    const d = new Date(iso)
    if (isNaN(d.getTime())) return null

    if (withTime) {
      return (
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      )
    }

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
  }

  const wrapData = (data, toUTC = false, withTime = false) => {
    if (!data) return data
    const newData = { ...data }

    dateFields.forEach((field) => {
      if (!newData[field]) return

      newData[field] = toUTC
        ? localToUTCISO(newData[field])
        : utcToLocalString(newData[field], withTime)
    })

    return newData
  }

  const update = async (affix, data, uuid) => {
    const payload = wrapData(data, true)
    const res = await store.update(affix, payload, uuid)
    return wrapData(res, false, true)
  }

  const create = async (affix, data) => {
    const payload = wrapData(data, true)
    const res = await store.create(affix, payload)
    return wrapData(res, false, true)
  }

  const read = async (affix, param) => {
    const res = await store.read(affix, param)
    return wrapData(res, false, true)
  }

  const readCustom = async (affix, params) => {
    const res = await store.readCustom(affix, params)
    return wrapData(res, false, true)
  }

  const getData = async (affix, params) => {
    const res = await store.getData(affix, params)
    return wrapData(res, false, true)
  }

  const getFilteredData = async (affix, filters) => {
    const res = await store.getFilteredData(affix, filters)
    return wrapData(res, false, true)
  }

  return { update, create, read, readCustom, getData, getFilteredData }
}
